/**
 * PostHog boolean feature flag. Must match the key configured in the
 * Grapevyne PostHog project dashboard.
 */
export const POSTHOG_FEATURE_IS_GRAPEVYNE_TEAM = 'IsGrapeVyneTeam'
